<template>
  <div class="container px-8 pt-16 mx-auto lg:px-16">
    <div class="flex flex-col md:flex-row">
      <img
        class="self-center object-contain md:p-8 mb-4 md:w-1/2 md:order-2"
        src="@/assets/img/closeupHardware.jpg"
        alt
        srcset
      />
      <div class="flex flex-col justify-center md:w-1/2 md:order-2 md:ml-8">
        <h2
          id="fonctionnement"
          class="text-3xl font-bold tracking-wider uppercase font-raleway"
        >
          Un dispositif santé high tech
        </h2>
        <hr class="mb-10 border border-green-500" />
        <p class="mb-10">
          En complément de la connaissance des différents comportement de leurs
          chats, la technologie HerdingCats offre la possibilité, par la
          connaissance fine des changements de comportement, bien avant que les
          propriétaires ne les détectent et ne les rapportent aux vétérinaires,
          d'effectuer un dépistage précoce et systématique des changements de
          comportements annonciateurs de la survenue des maladies, ce qui permet
          de diminuer les frais vétérinaires.
        </p>
        <!-- <a href="#" v-scroll-to="'#footer'"
          class="block px-4 py-4 font-bold leading-none tracking-wider text-center text-white uppercase bg-green-500 rounded-full shadow-md hover:bg-green-400 hover:shadow-lg">
          Découvrir HerdingCats en avant-première
        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
